/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.PatientApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BookingConfirmRequest,
  BookingConfirmResponse,
  BookingReserveResponse,
  CreateBookingRequest,
  DisplayAppointment,
  DisplayConcernsForPlatformLocation,
  DisplayPlatformLocationCoordinatesResponse,
  DisplayProvider,
  DisplayProviderAvailabilitySlot,
  PlatformLocationModel,
  PopulatePlatformLocationCoordinatesModel,
  RetrieveProviderAvailabilityForLocationParams,
  RetrieveProviderServicesForLocationParams,
  SalesAssociateModel,
  SyncBookingDataParams,
  WellnessProviderServiceInfo
} from '../model';

import { customAxios } from '../../custom-axios';
import type { ErrorType } from '../../custom-axios';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Retrieves active branch coordinates for the current platform, plus the branch nearest the visitor's
approximate CloudFront (IP-derived) position when CloudFront supplies one. The visitor's position is
only used to rank branches; it is never returned or logged.
 */
export const getPlatformLocationCoordinates = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayPlatformLocationCoordinatesResponse>(
      {url: `/api/v1/platform-location/coordinates`, method: 'GET', signal
    },
      options);
    }




export const getGetPlatformLocationCoordinatesQueryKey = () => {
    return [
    `/api/v1/platform-location/coordinates`
    ] as const;
    }


export const getGetPlatformLocationCoordinatesQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformLocationCoordinates>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationCoordinates>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformLocationCoordinatesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformLocationCoordinates>>> = ({ signal }) => getPlatformLocationCoordinates(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationCoordinates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlatformLocationCoordinatesQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformLocationCoordinates>>>
export type GetPlatformLocationCoordinatesQueryError = ErrorType<unknown>


export function useGetPlatformLocationCoordinates<TData = Awaited<ReturnType<typeof getPlatformLocationCoordinates>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationCoordinates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformLocationCoordinates>>,
          TError,
          Awaited<ReturnType<typeof getPlatformLocationCoordinates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformLocationCoordinates<TData = Awaited<ReturnType<typeof getPlatformLocationCoordinates>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationCoordinates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformLocationCoordinates>>,
          TError,
          Awaited<ReturnType<typeof getPlatformLocationCoordinates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformLocationCoordinates<TData = Awaited<ReturnType<typeof getPlatformLocationCoordinates>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationCoordinates>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves active branch coordinates for the current platform, plus the branch nearest the visitor's
approximate CloudFront (IP-derived) position when CloudFront supplies one. The visitor's position is
only used to rank branches; it is never returned or logged.
 */

export function useGetPlatformLocationCoordinates<TData = Awaited<ReturnType<typeof getPlatformLocationCoordinates>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationCoordinates>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlatformLocationCoordinatesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Retrieves a specific platform location by id.
 */
export const getPlatformLocation = (
    locationId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PlatformLocationModel>(
      {url: `/api/v1/platform-location/${locationId}`, method: 'GET', signal
    },
      options);
    }




export const getGetPlatformLocationQueryKey = (locationId: string,) => {
    return [
    `/api/v1/platform-location/${locationId}`
    ] as const;
    }


export const getGetPlatformLocationQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformLocation>>, TError = ErrorType<void>>(locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocation>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformLocationQueryKey(locationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformLocation>>> = ({ signal }) => getPlatformLocation(locationId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: locationId !== null && locationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlatformLocationQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformLocation>>>
export type GetPlatformLocationQueryError = ErrorType<void>


export function useGetPlatformLocation<TData = Awaited<ReturnType<typeof getPlatformLocation>>, TError = ErrorType<void>>(
 locationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformLocation>>,
          TError,
          Awaited<ReturnType<typeof getPlatformLocation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformLocation<TData = Awaited<ReturnType<typeof getPlatformLocation>>, TError = ErrorType<void>>(
 locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformLocation>>,
          TError,
          Awaited<ReturnType<typeof getPlatformLocation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformLocation<TData = Awaited<ReturnType<typeof getPlatformLocation>>, TError = ErrorType<void>>(
 locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocation>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a specific platform location by id.
 */

export function useGetPlatformLocation<TData = Awaited<ReturnType<typeof getPlatformLocation>>, TError = ErrorType<void>>(
 locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocation>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlatformLocationQueryOptions(locationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Retrieves the platform location for the current user.
 */
export const getPlatformUserLocation = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PlatformLocationModel>(
      {url: `/api/v1/platform-location`, method: 'GET', signal
    },
      options);
    }




export const getGetPlatformUserLocationQueryKey = () => {
    return [
    `/api/v1/platform-location`
    ] as const;
    }


export const getGetPlatformUserLocationQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformUserLocation>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformUserLocation>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformUserLocationQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformUserLocation>>> = ({ signal }) => getPlatformUserLocation(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformUserLocation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlatformUserLocationQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformUserLocation>>>
export type GetPlatformUserLocationQueryError = ErrorType<void>


export function useGetPlatformUserLocation<TData = Awaited<ReturnType<typeof getPlatformUserLocation>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformUserLocation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformUserLocation>>,
          TError,
          Awaited<ReturnType<typeof getPlatformUserLocation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformUserLocation<TData = Awaited<ReturnType<typeof getPlatformUserLocation>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformUserLocation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformUserLocation>>,
          TError,
          Awaited<ReturnType<typeof getPlatformUserLocation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformUserLocation<TData = Awaited<ReturnType<typeof getPlatformUserLocation>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformUserLocation>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the platform location for the current user.
 */

export function useGetPlatformUserLocation<TData = Awaited<ReturnType<typeof getPlatformUserLocation>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformUserLocation>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlatformUserLocationQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Returns `SalesAssociateModel`s for `PlatformUser`s `PlatformLocation`.
 */
export const getSalesAssociates = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SalesAssociateModel[]>(
      {url: `/api/v1/platform-location/sales-associates`, method: 'GET', signal
    },
      options);
    }




export const getGetSalesAssociatesQueryKey = () => {
    return [
    `/api/v1/platform-location/sales-associates`
    ] as const;
    }


export const getGetSalesAssociatesQueryOptions = <TData = Awaited<ReturnType<typeof getSalesAssociates>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSalesAssociates>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSalesAssociatesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSalesAssociates>>> = ({ signal }) => getSalesAssociates(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSalesAssociates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSalesAssociatesQueryResult = NonNullable<Awaited<ReturnType<typeof getSalesAssociates>>>
export type GetSalesAssociatesQueryError = ErrorType<unknown>


export function useGetSalesAssociates<TData = Awaited<ReturnType<typeof getSalesAssociates>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSalesAssociates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSalesAssociates>>,
          TError,
          Awaited<ReturnType<typeof getSalesAssociates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSalesAssociates<TData = Awaited<ReturnType<typeof getSalesAssociates>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSalesAssociates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSalesAssociates>>,
          TError,
          Awaited<ReturnType<typeof getSalesAssociates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSalesAssociates<TData = Awaited<ReturnType<typeof getSalesAssociates>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSalesAssociates>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns `SalesAssociateModel`s for `PlatformUser`s `PlatformLocation`.
 */

export function useGetSalesAssociates<TData = Awaited<ReturnType<typeof getSalesAssociates>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSalesAssociates>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSalesAssociatesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Starts a geocode of each listed platform location's current address. A location whose address changes
mid-geocode is geocoded again, so it never keeps the old address's coordinates.
 */
export const populatePlatformLocationCoordinates = (
    populatePlatformLocationCoordinatesModel: PopulatePlatformLocationCoordinatesModel,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platform-location/populate-coordinates`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: populatePlatformLocationCoordinatesModel, signal
    },
      options);
    }




export const getPopulatePlatformLocationCoordinatesMutationKey = () => ['populatePlatformLocationCoordinates'] as const;

export const getPopulatePlatformLocationCoordinatesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof populatePlatformLocationCoordinates>>, TError,PopulatePlatformLocationCoordinatesMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof populatePlatformLocationCoordinates>>, TError,PopulatePlatformLocationCoordinatesMutationVariables, TContext> => {

const mutationKey = getPopulatePlatformLocationCoordinatesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof populatePlatformLocationCoordinates>>, PopulatePlatformLocationCoordinatesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  populatePlatformLocationCoordinates(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PopulatePlatformLocationCoordinatesMutationResult = NonNullable<Awaited<ReturnType<typeof populatePlatformLocationCoordinates>>>
    export type PopulatePlatformLocationCoordinatesMutationBody = PopulatePlatformLocationCoordinatesModel
    export type PopulatePlatformLocationCoordinatesMutationError = ErrorType<unknown>
    export type PopulatePlatformLocationCoordinatesMutationVariables = {data: PopulatePlatformLocationCoordinatesModel}

    /**
 * @summary Starts a geocode of each listed platform location's current address. A location whose address changes
mid-geocode is geocoded again, so it never keeps the old address's coordinates.
 */
export const usePopulatePlatformLocationCoordinates = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof populatePlatformLocationCoordinates>>, TError,PopulatePlatformLocationCoordinatesMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof populatePlatformLocationCoordinates>>,
        TError,
        PopulatePlatformLocationCoordinatesMutationVariables,
        TContext
      > => {
      return useMutation(getPopulatePlatformLocationCoordinatesMutationOptions(options), queryClient);
    }
    /**
 * @summary Returns a list of available concerns for the specified platform location
 */
export const getConcerns = (
    locationId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayConcernsForPlatformLocation>(
      {url: `/api/v1/platform-location/${locationId}/concerns`, method: 'GET', signal
    },
      options);
    }




export const getGetConcernsQueryKey = (locationId: string,) => {
    return [
    `/api/v1/platform-location/${locationId}/concerns`
    ] as const;
    }


export const getGetConcernsQueryOptions = <TData = Awaited<ReturnType<typeof getConcerns>>, TError = ErrorType<unknown>>(locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConcerns>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConcernsQueryKey(locationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConcerns>>> = ({ signal }) => getConcerns(locationId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: locationId !== null && locationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConcerns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConcernsQueryResult = NonNullable<Awaited<ReturnType<typeof getConcerns>>>
export type GetConcernsQueryError = ErrorType<unknown>


export function useGetConcerns<TData = Awaited<ReturnType<typeof getConcerns>>, TError = ErrorType<unknown>>(
 locationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConcerns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConcerns>>,
          TError,
          Awaited<ReturnType<typeof getConcerns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConcerns<TData = Awaited<ReturnType<typeof getConcerns>>, TError = ErrorType<unknown>>(
 locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConcerns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConcerns>>,
          TError,
          Awaited<ReturnType<typeof getConcerns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConcerns<TData = Awaited<ReturnType<typeof getConcerns>>, TError = ErrorType<unknown>>(
 locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConcerns>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns a list of available concerns for the specified platform location
 */

export function useGetConcerns<TData = Awaited<ReturnType<typeof getConcerns>>, TError = ErrorType<unknown>>(
 locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConcerns>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConcernsQueryOptions(locationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get providers who can perform a specific service/package.
 */
export const retrieveProvidersByOfferedService = (
    locationId: string,
    packageId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayProvider[]>(
      {url: `/api/v1/platform-location/${locationId}/providers/by-service/${packageId}`, method: 'GET', signal
    },
      options);
    }




export const getRetrieveProvidersByOfferedServiceQueryKey = (locationId: string,
    packageId: string,) => {
    return [
    `/api/v1/platform-location/${locationId}/providers/by-service/${packageId}`
    ] as const;
    }


export const getRetrieveProvidersByOfferedServiceQueryOptions = <TData = Awaited<ReturnType<typeof retrieveProvidersByOfferedService>>, TError = ErrorType<void>>(locationId: string,
    packageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveProvidersByOfferedService>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRetrieveProvidersByOfferedServiceQueryKey(locationId,packageId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveProvidersByOfferedService>>> = ({ signal }) => retrieveProvidersByOfferedService(locationId,packageId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: locationId !== null && locationId !== undefined && packageId !== null && packageId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof retrieveProvidersByOfferedService>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RetrieveProvidersByOfferedServiceQueryResult = NonNullable<Awaited<ReturnType<typeof retrieveProvidersByOfferedService>>>
export type RetrieveProvidersByOfferedServiceQueryError = ErrorType<void>


export function useRetrieveProvidersByOfferedService<TData = Awaited<ReturnType<typeof retrieveProvidersByOfferedService>>, TError = ErrorType<void>>(
 locationId: string,
    packageId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveProvidersByOfferedService>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveProvidersByOfferedService>>,
          TError,
          Awaited<ReturnType<typeof retrieveProvidersByOfferedService>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRetrieveProvidersByOfferedService<TData = Awaited<ReturnType<typeof retrieveProvidersByOfferedService>>, TError = ErrorType<void>>(
 locationId: string,
    packageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveProvidersByOfferedService>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveProvidersByOfferedService>>,
          TError,
          Awaited<ReturnType<typeof retrieveProvidersByOfferedService>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRetrieveProvidersByOfferedService<TData = Awaited<ReturnType<typeof retrieveProvidersByOfferedService>>, TError = ErrorType<void>>(
 locationId: string,
    packageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveProvidersByOfferedService>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get providers who can perform a specific service/package.
 */

export function useRetrieveProvidersByOfferedService<TData = Awaited<ReturnType<typeof retrieveProvidersByOfferedService>>, TError = ErrorType<void>>(
 locationId: string,
    packageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveProvidersByOfferedService>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRetrieveProvidersByOfferedServiceQueryOptions(locationId,packageId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Unified booking sync endpoint that syncs all booking-related data from EMR in the correct order:
1. Providers and their service assignments
2. Service metadata for all platform locations
3. Provider availability (schedules, blockouts, and appointments)
 */
export const syncBookingData = (
    locationId: string,
    params?: SyncBookingDataParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<unknown>(
      {url: `/api/v1/platform-location/${locationId}/booking/sync`, method: 'POST',
        params, signal
    },
      options);
    }




export const getSyncBookingDataMutationKey = () => ['syncBookingData'] as const;

export const getSyncBookingDataMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncBookingData>>, TError,SyncBookingDataMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof syncBookingData>>, TError,SyncBookingDataMutationVariables, TContext> => {

const mutationKey = getSyncBookingDataMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncBookingData>>, SyncBookingDataMutationVariables> = (props) => {
          const {locationId,params} = props ?? {};

          return  syncBookingData(locationId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncBookingDataMutationResult = NonNullable<Awaited<ReturnType<typeof syncBookingData>>>

    export type SyncBookingDataMutationError = ErrorType<void>
    export type SyncBookingDataMutationVariables = {locationId: string;params?: SyncBookingDataParams}

    /**
 * @summary Unified booking sync endpoint that syncs all booking-related data from EMR in the correct order:
1. Providers and their service assignments
2. Service metadata for all platform locations
3. Provider availability (schedules, blockouts, and appointments)
 */
export const useSyncBookingData = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncBookingData>>, TError,SyncBookingDataMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof syncBookingData>>,
        TError,
        SyncBookingDataMutationVariables,
        TContext
      > => {
      return useMutation(getSyncBookingDataMutationOptions(options), queryClient);
    }
    /**
 * @summary Get wellness provider services (which providers can perform which services) for a specific location.
 */
export const retrieveProviderServicesForLocation = (
    locationId: string,
    params?: RetrieveProviderServicesForLocationParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<WellnessProviderServiceInfo[]>(
      {url: `/api/v1/platform-location/${locationId}/provider-services`, method: 'GET',
        params, signal
    },
      options);
    }




export const getRetrieveProviderServicesForLocationQueryKey = (locationId: string,
    params?: RetrieveProviderServicesForLocationParams,) => {
    return [
    `/api/v1/platform-location/${locationId}/provider-services`, ...(params ? [params] : [])
    ] as const;
    }


export const getRetrieveProviderServicesForLocationQueryOptions = <TData = Awaited<ReturnType<typeof retrieveProviderServicesForLocation>>, TError = ErrorType<void>>(locationId: string,
    params?: RetrieveProviderServicesForLocationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveProviderServicesForLocation>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRetrieveProviderServicesForLocationQueryKey(locationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveProviderServicesForLocation>>> = ({ signal }) => retrieveProviderServicesForLocation(locationId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: locationId !== null && locationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof retrieveProviderServicesForLocation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RetrieveProviderServicesForLocationQueryResult = NonNullable<Awaited<ReturnType<typeof retrieveProviderServicesForLocation>>>
export type RetrieveProviderServicesForLocationQueryError = ErrorType<void>


export function useRetrieveProviderServicesForLocation<TData = Awaited<ReturnType<typeof retrieveProviderServicesForLocation>>, TError = ErrorType<void>>(
 locationId: string,
    params: undefined |  RetrieveProviderServicesForLocationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveProviderServicesForLocation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveProviderServicesForLocation>>,
          TError,
          Awaited<ReturnType<typeof retrieveProviderServicesForLocation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRetrieveProviderServicesForLocation<TData = Awaited<ReturnType<typeof retrieveProviderServicesForLocation>>, TError = ErrorType<void>>(
 locationId: string,
    params?: RetrieveProviderServicesForLocationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveProviderServicesForLocation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveProviderServicesForLocation>>,
          TError,
          Awaited<ReturnType<typeof retrieveProviderServicesForLocation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRetrieveProviderServicesForLocation<TData = Awaited<ReturnType<typeof retrieveProviderServicesForLocation>>, TError = ErrorType<void>>(
 locationId: string,
    params?: RetrieveProviderServicesForLocationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveProviderServicesForLocation>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get wellness provider services (which providers can perform which services) for a specific location.
 */

export function useRetrieveProviderServicesForLocation<TData = Awaited<ReturnType<typeof retrieveProviderServicesForLocation>>, TError = ErrorType<void>>(
 locationId: string,
    params?: RetrieveProviderServicesForLocationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveProviderServicesForLocation>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRetrieveProviderServicesForLocationQueryOptions(locationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get provider availability for a specific location based on schedules and appointments.
 */
export const retrieveProviderAvailabilityForLocation = (
    locationId: string,
    params?: RetrieveProviderAvailabilityForLocationParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayProviderAvailabilitySlot[]>(
      {url: `/api/v1/platform-location/${locationId}/provider-availability`, method: 'GET',
        params, signal
    },
      options);
    }




export const getRetrieveProviderAvailabilityForLocationQueryKey = (locationId: string,
    params?: RetrieveProviderAvailabilityForLocationParams,) => {
    return [
    `/api/v1/platform-location/${locationId}/provider-availability`, ...(params ? [params] : [])
    ] as const;
    }


export const getRetrieveProviderAvailabilityForLocationQueryOptions = <TData = Awaited<ReturnType<typeof retrieveProviderAvailabilityForLocation>>, TError = ErrorType<void>>(locationId: string,
    params?: RetrieveProviderAvailabilityForLocationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveProviderAvailabilityForLocation>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRetrieveProviderAvailabilityForLocationQueryKey(locationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveProviderAvailabilityForLocation>>> = ({ signal }) => retrieveProviderAvailabilityForLocation(locationId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: locationId !== null && locationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof retrieveProviderAvailabilityForLocation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RetrieveProviderAvailabilityForLocationQueryResult = NonNullable<Awaited<ReturnType<typeof retrieveProviderAvailabilityForLocation>>>
export type RetrieveProviderAvailabilityForLocationQueryError = ErrorType<void>


export function useRetrieveProviderAvailabilityForLocation<TData = Awaited<ReturnType<typeof retrieveProviderAvailabilityForLocation>>, TError = ErrorType<void>>(
 locationId: string,
    params: undefined |  RetrieveProviderAvailabilityForLocationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveProviderAvailabilityForLocation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveProviderAvailabilityForLocation>>,
          TError,
          Awaited<ReturnType<typeof retrieveProviderAvailabilityForLocation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRetrieveProviderAvailabilityForLocation<TData = Awaited<ReturnType<typeof retrieveProviderAvailabilityForLocation>>, TError = ErrorType<void>>(
 locationId: string,
    params?: RetrieveProviderAvailabilityForLocationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveProviderAvailabilityForLocation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveProviderAvailabilityForLocation>>,
          TError,
          Awaited<ReturnType<typeof retrieveProviderAvailabilityForLocation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRetrieveProviderAvailabilityForLocation<TData = Awaited<ReturnType<typeof retrieveProviderAvailabilityForLocation>>, TError = ErrorType<void>>(
 locationId: string,
    params?: RetrieveProviderAvailabilityForLocationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveProviderAvailabilityForLocation>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get provider availability for a specific location based on schedules and appointments.
 */

export function useRetrieveProviderAvailabilityForLocation<TData = Awaited<ReturnType<typeof retrieveProviderAvailabilityForLocation>>, TError = ErrorType<void>>(
 locationId: string,
    params?: RetrieveProviderAvailabilityForLocationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveProviderAvailabilityForLocation>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRetrieveProviderAvailabilityForLocationQueryOptions(locationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get pending (reserved but not confirmed) appointments for the current user at this location.
Returns appointments with reservation expiry times for countdown timer display.
 */
export const platformLocationGetPendingAppointments = (
    locationId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayAppointment[]>(
      {url: `/api/v1/platform-location/${locationId}/pending-appointments`, method: 'GET', signal
    },
      options);
    }




export const getPlatformLocationGetPendingAppointmentsQueryKey = (locationId: string,) => {
    return [
    `/api/v1/platform-location/${locationId}/pending-appointments`
    ] as const;
    }


export const getPlatformLocationGetPendingAppointmentsQueryOptions = <TData = Awaited<ReturnType<typeof platformLocationGetPendingAppointments>>, TError = ErrorType<void>>(locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformLocationGetPendingAppointments>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformLocationGetPendingAppointmentsQueryKey(locationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformLocationGetPendingAppointments>>> = ({ signal }) => platformLocationGetPendingAppointments(locationId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: locationId !== null && locationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformLocationGetPendingAppointments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlatformLocationGetPendingAppointmentsQueryResult = NonNullable<Awaited<ReturnType<typeof platformLocationGetPendingAppointments>>>
export type PlatformLocationGetPendingAppointmentsQueryError = ErrorType<void>


export function usePlatformLocationGetPendingAppointments<TData = Awaited<ReturnType<typeof platformLocationGetPendingAppointments>>, TError = ErrorType<void>>(
 locationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformLocationGetPendingAppointments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformLocationGetPendingAppointments>>,
          TError,
          Awaited<ReturnType<typeof platformLocationGetPendingAppointments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformLocationGetPendingAppointments<TData = Awaited<ReturnType<typeof platformLocationGetPendingAppointments>>, TError = ErrorType<void>>(
 locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformLocationGetPendingAppointments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformLocationGetPendingAppointments>>,
          TError,
          Awaited<ReturnType<typeof platformLocationGetPendingAppointments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformLocationGetPendingAppointments<TData = Awaited<ReturnType<typeof platformLocationGetPendingAppointments>>, TError = ErrorType<void>>(
 locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformLocationGetPendingAppointments>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get pending (reserved but not confirmed) appointments for the current user at this location.
Returns appointments with reservation expiry times for countdown timer display.
 */

export function usePlatformLocationGetPendingAppointments<TData = Awaited<ReturnType<typeof platformLocationGetPendingAppointments>>, TError = ErrorType<void>>(
 locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformLocationGetPendingAppointments>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlatformLocationGetPendingAppointmentsQueryOptions(locationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Reserve a service booking for a specific location (Step 1: Initialize and Reserve).
This returns an appointment ID that must be confirmed within the reservation expiry time.
 */
export const reserveBooking = (
    locationId: string,
    createBookingRequest: CreateBookingRequest,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<BookingReserveResponse>(
      {url: `/api/v1/platform-location/${locationId}/book`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createBookingRequest, signal
    },
      options);
    }




export const getReserveBookingMutationKey = () => ['reserveBooking'] as const;

export const getReserveBookingMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reserveBooking>>, TError,ReserveBookingMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof reserveBooking>>, TError,ReserveBookingMutationVariables, TContext> => {

const mutationKey = getReserveBookingMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reserveBooking>>, ReserveBookingMutationVariables> = (props) => {
          const {locationId,data} = props ?? {};

          return  reserveBooking(locationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReserveBookingMutationResult = NonNullable<Awaited<ReturnType<typeof reserveBooking>>>
    export type ReserveBookingMutationBody = CreateBookingRequest
    export type ReserveBookingMutationError = ErrorType<void>
    export type ReserveBookingMutationVariables = {locationId: string;data: CreateBookingRequest}

    /**
 * @summary Reserve a service booking for a specific location (Step 1: Initialize and Reserve).
This returns an appointment ID that must be confirmed within the reservation expiry time.
 */
export const useReserveBooking = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reserveBooking>>, TError,ReserveBookingMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reserveBooking>>,
        TError,
        ReserveBookingMutationVariables,
        TContext
      > => {
      return useMutation(getReserveBookingMutationOptions(options), queryClient);
    }
    /**
 * @summary Confirm a reserved booking (Step 2: Confirm).
This finalizes the booking and creates the appointment in Zenoti.
 */
export const confirmBooking = (
    locationId: string,
    appointmentId: string,
    bookingConfirmRequest: BookingConfirmRequest,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<BookingConfirmResponse>(
      {url: `/api/v1/platform-location/${locationId}/book/${appointmentId}/confirm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bookingConfirmRequest, signal
    },
      options);
    }




export const getConfirmBookingMutationKey = () => ['confirmBooking'] as const;

export const getConfirmBookingMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmBooking>>, TError,ConfirmBookingMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof confirmBooking>>, TError,ConfirmBookingMutationVariables, TContext> => {

const mutationKey = getConfirmBookingMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmBooking>>, ConfirmBookingMutationVariables> = (props) => {
          const {locationId,appointmentId,data} = props ?? {};

          return  confirmBooking(locationId,appointmentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmBookingMutationResult = NonNullable<Awaited<ReturnType<typeof confirmBooking>>>
    export type ConfirmBookingMutationBody = BookingConfirmRequest
    export type ConfirmBookingMutationError = ErrorType<void>
    export type ConfirmBookingMutationVariables = {locationId: string;appointmentId: string;data: BookingConfirmRequest}

    /**
 * @summary Confirm a reserved booking (Step 2: Confirm).
This finalizes the booking and creates the appointment in Zenoti.
 */
export const useConfirmBooking = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmBooking>>, TError,ConfirmBookingMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmBooking>>,
        TError,
        ConfirmBookingMutationVariables,
        TContext
      > => {
      return useMutation(getConfirmBookingMutationOptions(options), queryClient);
    }
